import type { ExtensionFaq } from "./types";
import { DOCS } from "@/lib/constants";

/** Server-safe FAQ content (no icons), shared by the client config and the page JSON-LD. */
function build(browserLabel: string, storeName: string, socks: string): ExtensionFaq[] {
  return [
    {
      q: "Is the Proxidize proxy extension free?",
      a: `Yes. The extension is completely free to install from the ${storeName} and works with any standard proxy. No Proxidize account required.`,
    },
    {
      q: "When should I use the extension?",
      a: "Any time you want to route your browser through a proxy without changing system-wide settings: switching between proxies while managing multiple sessions, testing how a site behaves from different locations, or keeping one browser behind a proxy while the rest of your device connects directly.",
      link: { label: "When to use the extension: full guide", href: DOCS.proxyExtensionWhenToUse },
    },
    {
      q: "Does it work with proxies from other providers?",
      a: "Yes. It works with any standard proxy you already have. It also pairs perfectly with Proxidize mobile and residential proxies for reliable, unblocked connections.",
    },
    {
      q: "Which proxy types are supported?",
      a: socks,
    },
    {
      q: "Can I rotate my IP without reconnecting?",
      a: "Yes. You can get a fresh IP in one click, using session-based rotation for residential gateways and rotation links for mobile and dedicated proxies, without disconnecting or re-entering your proxy. A confirmation step protects you from accidental rotations.",
    },
    {
      q: "Can I send specific sites through different proxies?",
      a: "Yes. Smart routing lets you keep one main proxy and add per-site exceptions to route chosen sites through a different proxy or connect them directly, with a global bypass list and a master switch to toggle every rule at once.",
    },
    {
      q: "Does it prevent IP leaks?",
      a: "Yes. Built-in WebRTC leak protection stops your real IP from leaking through WebRTC while you're connected, and the connection indicator turns into a shield so you can see it's active.",
    },
    {
      q: "What data does the extension collect?",
      a: "The extension runs locally in your browser. Your proxy list stays on your device. Permissions are used only to apply proxy settings and to detect a proxy's IP and country.",
    },
    {
      q: `Do I need an account to use it in ${browserLabel}?`,
      a: "No account is needed to install and use the extension. To get fast, ethically sourced proxies to plug in, you can start a free Proxidize trial.",
    },
  ];
}

export const chromeFaqs = build(
  "Chrome",
  "Chrome Web Store",
  "HTTP, HTTPS, SOCKS v4, and SOCKS v5 proxies are all supported."
);

export const firefoxFaqs = build(
  "Firefox",
  "Firefox Add-ons",
  "HTTP, HTTPS, and SOCKS proxies are supported."
);
